// extracted by mini-css-extract-plugin
export default {"container":"LandingPageNewsLetterSignUp_container__UpkV5","warning":"LandingPageNewsLetterSignUp_warning__H2Ep2"};